module.exports = __webpack_public_path__ + "static/img/White Sugar.36ba795.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/White Sugar.jpg
// module id = 9Mty
// module chunks = 0